import { render, staticRenderFns } from "./ClientCargo.vue?vue&type=template&id=c63d5974&scoped=true"
import script from "./ClientCargo.vue?vue&type=script&lang=js"
export * from "./ClientCargo.vue?vue&type=script&lang=js"
import style0 from "./ClientCargo.vue?vue&type=style&index=0&id=c63d5974&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c63d5974",
  null
  
)

export default component.exports